var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossCircleSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.92332 14.5091l3.7162-3.7162c.39053-.39053 1.0237-.39053 1.41422 0 .39052.39052.39052 1.02368 0 1.4142l-3.71621 3.71622 3.7162 3.7162c.39053.39053.39053 1.0237 0 1.41422-.39052.39052-1.02368.39052-1.4142 0l-3.71621-3.71621-3.71621 3.7162c-.39053.39053-1.0237.39053-1.41422 0-.39052-.39052-.39052-1.02368 0-1.4142l3.71621-3.71621-3.7162-3.71621c-.39053-.39053-.39053-1.0237 0-1.41422.39052-.39052 1.02368-.39052 1.4142 0l3.71622 3.71621zM16 30C8.26801 30 2 23.73199 2 16S8.26801 2 16 2s14 6.26801 14 14-6.26801 14-14 14zm0-2c6.62742 0 12-5.37258 12-12S22.62742 4 16 4 4 9.37258 4 16s5.37258 12 12 12z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleSmall);
export default __webpack_public_path__ + "static/media/crossCircleSmall.2bfe7934.svg";
export { ForwardRef as ReactComponent };